import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, articleCounts }) => {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant={activeCategory === 'all' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onCategoryChange('all')}
        className="flex items-center space-x-2"
      >
        <Icon name="Grid3X3" size={16} />
        <span>All Articles</span>
        <span className="ml-1 px-2 py-0.5 bg-muted rounded-full text-xs">
          {articleCounts?.all}
        </span>
      </Button>
      {categories?.map((category) => (
        <Button
          key={category?.id}
          variant={activeCategory === category?.id ? 'default' : 'outline'}
          size="sm"
          onClick={() => onCategoryChange(category?.id)}
          className="flex items-center space-x-2"
        >
          <Icon name={category?.icon} size={16} />
          <span>{category?.name}</span>
          <span className="ml-1 px-2 py-0.5 bg-muted rounded-full text-xs">
            {articleCounts?.[category?.id] || 0}
          </span>
        </Button>
      ))}
    </div>
  );
};

export default CategoryFilter;